import { render, staticRenderFns } from "./AgendaTipologieListComponent.vue?vue&type=template&id=0c9cb00f"
import script from "./AgendaTipologieListComponent.vue?vue&type=script&lang=js"
export * from "./AgendaTipologieListComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaTipologieListComponent.vue?vue&type=style&index=0&id=0c9cb00f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports